import z from "zod";

import { EncounterAmendmentReason } from "@/encounters/constants/encounter-amendment-reason";
import { zCoding } from "@/utils/zod";

// Base schema with optional reason (for form initialization)
export const EncounterAmendmentFormValues = z
  .object({
    encounterAmendmentInfoReason: z
      .union([
        zCoding().refine((value) => value.code !== "", {
          message: "Reason is required",
        }),
        z.string().min(1, { message: "Reason is required" }),
      ])
      .optional(),
    encounterAmendmentInfoSpecify: z.string().optional(),
    encounterAmendmentInfoNotes: z.string().optional(),
    encounterAmendmentInfoNotifyClient: z.boolean().optional(),
  })
  .refine(
    (data) => {
      if (data.encounterAmendmentInfoReason === EncounterAmendmentReason.Other) {
        return data.encounterAmendmentInfoSpecify !== undefined;
      }
      return true;
    },
    {
      message: "Specify field is required when 'Other' is selected",
      path: ["encounterAmendmentInfoSpecify"],
    },
  );

// Schema for validating amendment info when signing and locking (requires reason)
export const EncounterAmendmentFormValuesRequired = z
  .object({
    encounterAmendmentInfoReason: z.union([
      zCoding().refine((value) => value.code !== "", {
        message: "Reason is required",
      }),
      z.string().min(1, { message: "Reason is required" }),
    ]),
    encounterAmendmentInfoSpecify: z.string().optional(),
    encounterAmendmentInfoNotes: z.string().optional(),
    encounterAmendmentInfoNotifyClient: z.boolean().optional(),
  })
  .refine(
    (data) => {
      if (data.encounterAmendmentInfoReason === EncounterAmendmentReason.Other) {
        return data.encounterAmendmentInfoSpecify !== undefined;
      }
      return true;
    },
    {
      message: "Specify field is required when 'Other' is selected",
      path: ["encounterAmendmentInfoSpecify"],
    },
  );

export type EncounterAmendmentFormValuesType = z.infer<typeof EncounterAmendmentFormValues>;
